import { render, staticRenderFns } from "./ChildrenDetail.vue?vue&type=template&id=ce51a67a&scoped=true&"
import script from "./ChildrenDetail.vue?vue&type=script&lang=js&"
export * from "./ChildrenDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenDetail.vue?vue&type=style&index=0&id=ce51a67a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce51a67a",
  null
  
)

export default component.exports